export default [
  {
    path: '',
    name: 'coupon_template_list',
    component: () => import('./List'),
  },
  {
    path: 'new',
    name: 'coupon_template_new',
    component: () => import('./New'),
  },
  {
    path: ':id',
    name: 'coupon_template_detail',
    component: () => import('./Detail'),
    props: true,
  },
  {
    path: ':id/edit',
    name: 'coupon_template_edit',
    component: () => import('./Edit'),
    props: true,
  },
]
